export default "__VITE_ASSET__B$mn1PLJ__"